import {Link} from '@mdsol/onex-design'
import React from 'react'
import {FC} from 'react'
import {CellPropsType} from './cellPropsType'
import {jobRequestAC, fetchJobRequestDetails} from '../../../../../redux/jobRequests/jobRequests.duck'
import {useAppDispatch} from 'redux/config'
import './requestId.scss'
import {useSelector} from 'react-redux'
import {select_requestIdDetails} from 'redux/jobRequests/selectors'

const RequestId: FC<CellPropsType> = ({cell}) => {
  const dispatch = useAppDispatch()
  const value = cell.getValue()
  const requestIdSelected = useSelector(select_requestIdDetails)
  const displayRowDetails = () => {
    if (requestIdSelected === value) {
      dispatch(jobRequestAC.hideDetails())
      dispatch(jobRequestAC.requestIdDetailsApplied(''))
    } else {
      dispatch(jobRequestAC.showDetails())
      dispatch(jobRequestAC.showDataLoadRequestFormClose())
      dispatch(jobRequestAC.requestIdDetailsApplied(value))
      dispatch(fetchJobRequestDetails(value))
    }
  }

  return (
    <Link
      key={`link-dataload-request-details-${value}`}
      dataTestId='dataload-request-details'
      variant='secondary'
      onClick={displayRowDetails}
    >
      {value}
    </Link>
  )
}

export default RequestId
